/**
 * @type {BaseRoute[]}
 */
export const routes = [
    {
        path: '/', component: 'x-main-layout',
        children: [
            {path: '/home', component: 'x-home-page'},
            {path: '/financial', component: 'x-financial-page'},
            {path: '/settings', component: 'x-settings-page'},
        ],
    }
];